import React from 'react';

const Disclaimer: React.FC = () => {
  return (
    <p className="disclaimer">
      Important Disclaimer: This calculator is for informational purposes only and is NOT a substitute for professional
      medical advice. Always verify your dose with your healthcare provider. Productist LLC is not responsible or liable
      for any consequences of using this tool.
    </p>
  );
};

export default Disclaimer;
